import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppContext } from 'contexts';
import ChatBubbleRoundedIcon from '@material-ui/icons/ChatBubbleRounded';

const useStyles = makeStyles({
  chatContent: {
    position: 'absolute',
    bottom: 50,
    right: 50,
    width: 70,
    height: 70,
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    cursor: 'pointer',
    '@media (max-width: 768px)': {
      bottom: 50,
      right: 20,
    },
    backgroundColor: '#00bdf2',
  },
  chatIcon: {
    fontSize: 30,
    color: 'white',
  },
});

function ChatBubbleIcon() {
  const classes = useStyles();
  const appContext = useContext(AppContext);
  const { setDisplayChatModal } = appContext;
  const onClickChat = () => {
    setDisplayChatModal(true);
  };

  return (
    <div className={classes.chatContent} onClick={onClickChat} onTouchEnd={onClickChat}>
      <ChatBubbleRoundedIcon className={classes.chatIcon} />
    </div>
  );
}

export default ChatBubbleIcon;
